<template>
  <!-- Job Section -->
  <section class="cta-section job-section-eight">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 position-relative aos" data-aos="fade-up">
          <div class="job-img">
            <img src="@/assets/img/job-img.png" class="img-fluid" alt="CTA" />
          </div>
          <div class="job-role job-one">
            <div class="job-role-img">
              <img
                src="@/assets/img/icons/job-role.png"
                class="img-fluid"
                alt="CTA"
              />
            </div>
            <div class="job-title">
              <p>Total Employees Hired</p>
              <h3><span class="counterUp">1.5</span>M+</h3>
            </div>
          </div>
          <div class="job-role job-two">
            <div class="job-role-img">
              <img
                src="@/assets/img/icons/job-role.png"
                class="img-fluid"
                alt="CTA"
              />
            </div>
            <div class="job-title">
              <p>Platform downloaded</p>
              <h3><span class="counterUp">5</span>M+</h3>
            </div>
          </div>
          <div class="job-role job-three">
            <div class="job-role-img">
              <img
                src="@/assets/img/icons/job-role.png"
                class="img-fluid"
                alt="CTA"
              />
            </div>
            <div class="job-title">
              <p>Total Jobs</p>
              <h3><span class="counterUp">5</span>M+</h3>
            </div>
          </div>
          <div class="job-role job-four">
            <div class="job-role-img">
              <img
                src="@/assets/img/icons/job-role.png"
                class="img-fluid"
                alt="CTA"
              />
            </div>
            <div class="job-title">
              <p>Company satisfied rate</p>
              <h3><span class="counterUp">5</span>M+</h3>
            </div>
          </div>
        </div>
        <div class="col-lg-6 aos" data-aos="fade-up">
          <div class="cta-content job-content">
            <div class="section-heading heading-eight">
              <h2>How It Works</h2>
              <p class="vaca-para">
                Lorem Ipsum is simply dummy text of the printing
              </p>
            </div>
            <div class="preferred-part">
              <div class="prefer-img">
                <img
                  src="@/assets/img/icons/icons-2.png"
                  class="img-fluid"
                  alt="no-img"
                />
              </div>
              <div class="preferred-content">
                <h5>Search for you preferred Job</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut et dolore magna aliqua.
                </p>
              </div>
            </div>
            <div class="preferred-part">
              <div class="prefer-img">
                <img
                  src="@/assets/img/icons/icons-9.png"
                  class="img-fluid"
                  alt="no-img"
                />
              </div>
              <div class="preferred-content">
                <h5>Search for you preferred Job</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut et dolore magna aliqua.
                </p>
              </div>
            </div>
            <div class="preferred-part">
              <div class="prefer-img">
                <img
                  src="@/assets/img/icons/icons-11.png"
                  class="img-fluid"
                  alt="no-img"
                />
              </div>
              <div class="preferred-content">
                <h5>Search for you preferred Job</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut et dolore magna aliqua.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Job Section -->
</template>
